import { Injectable } from '@angular/core';
import { Calendar } from '@ionic-native/calendar';
import { Subject } from 'rxjs/Subject'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'

//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';
import { CongressoProvider } from '../providers/congresso-provider';
//Components
import { CustomAlert } from '../components/custom-alert.component';
import { CustomToastComponent } from '../components/custom-toast/custom-toast';
//Models
import { Activity } from '../models/activity.model';
import { DayProgram } from '../models/day-program.model';
import { Congresso } from '../models/congresso.model';
import { User } from '../models/user.model';

@Injectable()
export class CalendarProvider {
    private DEFAULTNAME: string;
    private DEFAULTCOLOR: string;
    public _calendarName: string;
    public isAndroid: boolean;
    public isIos: boolean;
    public minutes: number;
    public allowCalendar: boolean;
    public hasCalendar: boolean;
    public congressos: Array<Congresso>;


    constructor(public configProvider: ConfigProvider,
        private utilProvider: UtilProvider,
        private congressoProvider: CongressoProvider,
        private alert: CustomAlert,
        private toast: CustomToastComponent,
        private calendar: Calendar) {


        if (localStorage.getItem('congressos') != null && localStorage.getItem('congressos') != "undefined") {
            this.congressos = JSON.parse(localStorage.getItem('congressos')) as Array<Congresso>;;
        }

        
        this.isAndroid = utilProvider.getPlatform() == 'android';
        this.isIos = utilProvider.getPlatform() == 'ios';
        this.DEFAULTNAME = `SOGESP - Congresso ${this.configProvider.ANO_ATUAL}`
        this.DEFAULTCOLOR = '#C91544';
        this.minutes = +localStorage.getItem('config');
        this.allowCalendar = +localStorage.getItem('config') > 0;
    }

    open() {
        this.calendar.openCalendar(new Date()).then(
            (msg) => { },
            (err) => { this.alert.showAlert('Erro', 'Erro ao abrir  agenda.') }
        );
    }

    create(name: string, color: string): Promise<any> {
        let self = this;
        if (this.utilProvider.isNullOrEmpty(name) || this.utilProvider.isUndefined(name))
            name = this.DEFAULTNAME;

        self._calendarName = name;

        if (self.utilProvider.isNullOrEmpty(color) || this.utilProvider.isUndefined(color)) {
            this.congressos = JSON.parse(localStorage.getItem('congressos')) as Array<Congresso>;
            color = this.congressos ? this.congressos[0].CorPrimaria : this.DEFAULTCOLOR;
        }


        if (self.utilProvider.getPlatform() == 'ios' && !localStorage.getItem('calendar')) {

            return self.calendar.createCalendar({ calendarName: this._calendarName, calendarColor: color }).then(
                () => {
                    localStorage.setItem('calendar', 'true');
                    return Promise.resolve(self)
                },
                (err) => {
                    self.toast.show('Ocorreu uma falha ao criar o calendário. Verifique as permissões do aplicativo SOGESP no seu dispositivo', 5000, 'bottom');
                    return Promise.resolve(false);
                }
            );
        }
        else {
            return Promise.resolve(self);
        }
    }

    reset(name: string, color: string): Promise<any> {
        let self = this;
        if (self.utilProvider.isNullOrEmpty(name) || this.utilProvider.isUndefined(this._calendarName))
            name = self.DEFAULTNAME;

        self._calendarName = name;

        self.remove();
        return self.create(name, color)
            .then((data) => {
                return Promise.resolve(data);
            });

    }

    setActivities(activitiesIds: number[]) {
        let self = this;
        self.calendar.hasReadWritePermission().then((success) => {
            if (!success) {
                self.calendar.requestReadWritePermission().then((success) => {
                    if (!success) {
                        this.toast.show('Não é possível solicitar permissões do calendário', 5000, 'bottom');
                    } else {
                        self.addActivities(activitiesIds);
                    }
                });
            } else {
                self.addActivities(activitiesIds);
            }
        });
    }

    addActivities(activitiesIds: number[]) {
        let activities = this.getAllActivities();
        if (activities.length) {
            for (let i = 0; i < activitiesIds.length; i++) {
                let atividade = activities.filter(a => a.AtividadeId == activitiesIds[i])[0] as Activity;
                this.addActivity(atividade, false);
            }

        }
        else {
            this.toast.show('Não foi possível adicionar as atividades no calendário.', 3000, 'bottom');
        }
    }

    addActivitiesRecursive(activitiesIds: number[]) {
        return this.createSingle(activitiesIds, 0).then(
            (success) => {
                this.toast.show('Atividades adicionadas no calendário com sucesso.', 3000, 'bottom');
            },
            (err) => {
                this.toast.show('Não foi possível adicionar as atividades no calendário. Verifique as permissões do aplicativo SOGESP no seu dispositivo.', 3000, 'bottom');
            });
    }

    createSingle(activitiesIds, i): Promise<any> {
        let activities = this.getAllActivities();
        let atividade = activities.filter(a => a.AtividadeId == activitiesIds[i])[0] as Activity;

        return new Promise((resolve, reject) => {

            if (i < activitiesIds.length) {
                this.add(atividade, activitiesIds, i);
            }
            else {
                reject('error');
            }
        });
    }

    add(activity: Activity, events: number[], i) {
        this.minutes = +localStorage.getItem('config');

        if (this.minutes == undefined || this.minutes == 0)
            this.minutes = null;

        var date = activity.DiaData.split('/').map(Number),
            init = activity.HoraInicioAtividade.split(':').map(Number),
            end = activity.HoraFimAtividade.split(':').map(Number);

        let title = activity.Sigla + ' ' + activity.OrdemAtividade + ' - ' + activity.TemaDaAtividade;
        let location = activity.SiglaSala + ' - ' + activity.DescritivoSala;
        let note = activity.Descricao;
        let startDate = new Date(date[2], (date[1] - 1), date[0], init[0], init[1], 0, 0);
        let endDate = new Date(date[2], (date[1] - 1), date[0], end[0], end[1], 0, 0);

        let options: any = {
            calendarName: this._calendarName,
            firstReminderMinutes: this.minutes,
        };

        this.calendar.createEventWithOptions(title, location, note, startDate, endDate, options).then(
            () => { this.createSingle(events, i + 1) },
            (err) => { this.toast.show('Ocorreu um erro ao tentar adicionar ma atividade no calendário. Verifique as permissões do aplicativo SOGESP no seu dispositivo.', 3000, 'bottom'); });
    }


    insertActivity(activity: Activity) {
        let self = this;
        let activities = this.getAllActivities();
        let atividade = activities.filter(a => a.AtividadeId == activity.AtividadeId)[0] as Activity;
        self.calendar.hasReadWritePermission().then((success) => {
            if (!success) {
                self.calendar.requestReadWritePermission().then((success) => {
                    if (!success) {
                        this.toast.show('Não há permissão para adicionar atividades no calendário do celular.', 5000, 'bottom');
                    } else {
                        this.toast.show('Não foi possível adicionar a atividade no calendário. Verifique as permissões do aplicativo SOGESP no seu dispositivo.', 3000, 'bottom')
                    }
                });
            } else {
                self.addActivity(atividade, true);
            }
        });
    }

    addActivity(activity: Activity, showMessage: boolean) {

        this.minutes = +localStorage.getItem('config');

        if (this.minutes == undefined || this.minutes == 0)
            this.minutes = null;

        var date = activity.DiaData.split('/').map(Number),
            init = activity.HoraInicioAtividade.split(':').map(Number),
            end = activity.HoraFimAtividade.split(':').map(Number);

        let title = activity.Sigla + ' ' + activity.OrdemAtividade + ' - ' + activity.TemaDaAtividade;
        let location = activity.SiglaSala + ' - ' + activity.DescritivoSala;
        let note = activity.Descricao;
        let startDate = new Date(date[2], (date[1] - 1), date[0], init[0], init[1], 0, 0);
        let endDate = new Date(date[2], (date[1] - 1), date[0], end[0], end[1], 0, 0);

        let options: any = {
            calendarName: this._calendarName,
            firstReminderMinutes: this.minutes,
        };

        this.calendar.createEventWithOptions(title, location, note, startDate, endDate, options).then(
            () => {
                if (showMessage)
                    this.toast.show('Atividade adicionada no calendário', 3000, 'bottom')
            }, () => {
                this.toast.show('Não foi possível adicionar a atividade no calendário. Verifique as permissões do aplicativo SOGESP no seu aparelho.', 3000, 'bottom')
            }
        );
    }

    remove() {
        if (this.isIos) {

            this.calendar.deleteCalendar(this._calendarName ? this._calendarName : this.DEFAULTNAME).then(
                (msg) => { },
                (err) => { this.toast.show('Erro ao remover calendário. Verifique as permissões do aplicativo SOGESP no seu aparelho.', 3000, 'bottom') }
            );

            localStorage.removeItem('calendar');
        }
        else if (this.isAndroid) {
            let atividadesInscritas = JSON.parse(localStorage.getItem('atividadesInscritas')) as number[];

            this.removeActivities(atividadesInscritas, true);
        }

        this.hasCalendar = false;
    }

    removeActivities(activitiesIds: number[], showMessage: boolean) {
        let self = this;
        let activities = self.getAllActivities();
        if (activities && activities.length) {
            let i = 0;

            activitiesIds.forEach(x => {

                let atividade = activities.filter(a => a.AtividadeId == x)[0] as Activity;
                this.removeActivity(atividade, false);
                i++;
            });

            if (i >= activitiesIds.length && showMessage)
                this.toast.show('Atividades removidas do calendário', 3000, 'bottom');
        }
        else
            this.toast.show('Não foi possível remover as atividades do calendário', 3000, 'bottom');
    }

    deleteActivity(activity: Activity) {
        let self = this;
        let activities = this.getAllActivities();
        let atividade = activities.filter(a => a.AtividadeId == activity.AtividadeId)[0] as Activity;
        self.calendar.hasReadWritePermission().then((success) => {
            if (!success) {
                self.calendar.requestReadWritePermission().then((success) => {
                    if (!success) {
                        this.toast.show('Não há permissão para remover atividades no calendário do celular.', 3000, 'bottom');
                    } else {
                        self.removeActivity(atividade, true);
                    }
                });
            } else {
                self.removeActivity(atividade, true);
            }
        });
    }

    removeActivity(activity: Activity, showMessage: boolean) {

        var date = activity.DiaData.split('/').map(Number),
            init = activity.HoraInicioAtividade.split(':').map(Number),
            end = activity.HoraFimAtividade.split(':').map(Number);

        let title = activity.Sigla + ' ' + activity.OrdemAtividade + ' - ' + activity.TemaDaAtividade;
        let location = activity.SiglaSala + ' - ' + activity.DescritivoSala;
        let note = activity.Descricao;
        let startDate = new Date(date[2], (date[1] - 1), date[0], init[0], init[1], 0, 0);
        let endDate = new Date(date[2], (date[1] - 1), date[0], end[0], end[1], 0, 0);


        if (this.isIos) {
            this.calendar.deleteEventFromNamedCalendar(title, location, note, startDate, endDate, this._calendarName).then(data => {
                if (showMessage)
                    this.toast.show('Atividade removida do calendário.', 3000, 'bottom');
            });

        }
        else {
            this.calendar.deleteEvent(title, location, note, startDate, endDate).then(data => {
                if (showMessage)
                    this.toast.show('Atividade removida do calendário.', 3000, 'bottom');
            });
        }
    }

    returnError(err) {
        if (err != '' && this.isAndroid)
            this.alert.showAlert('Atenção', 'O aplicativo SOGESP não tem permissão para usar o calendário. Para liberar o acesso, vá até as configurações e ative o calendário');
        else if (err != '' && this.isAndroid)
            this.alert.showAlert('Atenção', 'Não foi possível salvar no calendário.');
    }

    getAllActivities(): Array<Activity> {

        let days = JSON.parse(localStorage.getItem('programacaoAtual')) as Array<DayProgram>;
        let activities = new Array<Activity>();
        if (days && days.length) {
            //this.alert.showAlert('dias', days.length.toString());

            days.forEach(x => {
                Array.prototype.push.apply(activities, x.Atividades);
            });
            return activities;
        }

    }
}



// WEBPACK FOOTER //
// ./src/providers/calendar-provider.ts